import '../firebase';
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { firestorePlugin } from 'vuefire'

// import Mapvue from './components/Map.vue'
import router from './router'

import { store } from '../store';


Vue.config.productionTip = false
Vue.use(firestorePlugin);
Vue.use(VueRouter);
Vue.use(VueSweetalert2);



// const Foo = {
//   template: '<div>Foo component!</div>'
// };

// const Bar = {
//   template: '<div>Bar component!</div>'
// };
// const routes = [
//   { path: '/foo', name: 'Foo', component: Foo },
//   { path: '/bar', name: 'Bar',component: Bar },
// ]
// const router = new VueRouter({
//   routes,
//   mode:'history'
// });
//const router = new VueRouter({ routes });

router.beforeEach((to, from, next) => {
  /* const encryptedText = this.CryptoJS.AES.encrypt("Kamleshkns", "corekaresKNS7*!*").toString()
const decryptedText = this.CryptoJS.AES.decrypt(encryptedText, "corekaresKNS7*!*").toString(this.CryptoJS.enc.Utf8) */
  // const txt="{
  // 	"employee": {
  // 		"name": "sonoo",
  // 		"salary": 56000,
  // 		"married": true
  // 	}
  // }";

  console.log("------asd")
  console.log(store.state.user);
  console.log("------asd------------")

  const record = to.matched.find(record => record.meta.role);
  console.log("cookie")
  console.log(record);


  // } else {
  //   console.log("-----hello---------");
  //   console.log(to);
  //   console.log(from);
  console.log(next);
  //   console.log("end-----hello---------end");
  //   next();
  // }
 

  if (store.state.user != '') {
    console.log("cant")
    let users = store.state.user;

    // if (record == undefined) {
    //   next("sign-in")
    // }
    // else {
    switch (record.meta.role) {


      case 'basic':
        if (users.roles.permission >= 1) {
          next();
        } else {
          next('/cafes');
        }
        break;
      case 'gold':
        if (users.roles.permission >= 2) {
          next();
        } else {
          next('/cafes');
        }
        break;
      case 'plan':
        if (users.roles.permission == 3) {
          next();
        } else {
          next('/cafes');
        }
        break;
    }
    //  }
    next();
  } else {
    //console.log("can");

  }
  next();
})


new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
